import { Component } from '@angular/core';

@Component({
  selector: 'app-light-switch',
  standalone: true,
  imports: [],
  templateUrl: './light-switch.component.html',
  styleUrl: './light-switch.component.scss'
})
export class LightSwitchComponent {
  changeMode(e:any) {
    e.preventDefault();

    const htmlTag = document.documentElement;
    if (htmlTag.className.includes("dark")) {
      htmlTag.className = 'light'
      localStorage.setItem('fsbr-theme', 'light');
    } else {
      htmlTag.className = 'dark'
      localStorage.setItem('fsbr-theme', 'dark');
    }
  }
}
